import {reduxForm, Field, formValueSelector, FieldArray} from 'redux-form'
import styles from './style.css'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import WarningMessage from 'components/WarningMessage/WarningMessage'
import {
  onClickCancel,
  deleteSalesTypeRequest,
  activatedSalesTypeRequest
} from 'actions/library/salesType'
import SalesTypeGratuity from './SalesTypeGratuity'
import {connect} from 'react-redux'

const validate = (values) => {
  const errors = {}
  if ((!values.name) || (values.name.trim() === '')) {
    errors.name = 'This field is required'
  }
  if (values.name && values.name.length > 25) {
    errors.name = 'Sales Type Name should be less than 25 characters'
  }
  return errors
}

class SalesTypeForm extends React.Component {
  constructor (props) {
    super(props)
    this.scrollArea = null
  }
  componentWillReceiveProps (nextProps) {
    if (nextProps.mustScrollTop) {
      this.scrollArea.scrollTop = 0
    }
  }
  render () {
    let {handleSubmit, isSubmittingForm, salesTypeDetail, outlets, gratuity, enableGratuity} = this.props
    let textActivatedBtn = ''
    let styleBtnColor = ''
    let isActivate = salesTypeDetail && salesTypeDetail.active_state === true
    isActivate ? textActivatedBtn = 'Deactivate' : textActivatedBtn = 'Reactivate'
    isActivate ? styleBtnColor = `btn btn-danger ${styles['btnActivate']}` : styleBtnColor = `btn btn-primary ${styles['btnActivate']}`
    return (
      <div onSubmit={this.props.handleSubmit} className={`${styles.wrapper} sales-type-wrapper-form`}>
        <div ref={(a) => { this.scrollArea = a }} className={!enableGratuity ? `${styles['item-fieldset-without-gratuity-warning']} sales-type-item-fieldset` : `${styles['item-fieldset']} sales-type-item-fieldset`} >
          <div className={styles.title}>
            Sales Type Information
          </div>
          <div className='row'>
            <div className='col-sm-12'>
              <div className='col-sm-12 col-md-12 no-padding'>
                <Field
                  component={SettingField}
                  name='name'
                  className='form-control'
                  placeholder='Sales Type Name (e.g. Dine In)'
                />
              </div>
            </div>
            <div className={`col-lg-12 ${styles['margin-top-30']}`}>
              <div className='form-group'>
                <label className={`${styles['label-input']}`}>Assign Gratuity</label>
                {gratuity.results && gratuity.results.length > 0 ? <FieldArray
                  name='active_gratuities'
                  component={SalesTypeGratuity}
                  gratuity={gratuity}
                /> : <div className={styles.textNoGratuity}>
                  No Gratuity found. Go to Gratuity page to manage Gratuity
                </div>}
              </div>
            </div>
          </div>
        </div>
        <div className={!enableGratuity ? styles.footerWithoutGratuityWarning : styles.footer}>
          { !enableGratuity && <div className={styles['warning-message']}>
            <WarningMessage addPadding={styles['addPadding']} message='Your Checkout Settings for Gratuity is disabled. The Gratuity will not be applied to the transactions' />
          </div>}
          {salesTypeDetail && salesTypeDetail.id &&
          <span className='pull-left'>
            <button className='btn btn-danger'
              onClick={this._onClickDelete}
              type='button'
              disabled={isSubmittingForm}>
              <i className='fa fa-trash' />
            </button>
            <button
              type='button'
              className={styleBtnColor}
              onClick={this._onClickActivated}
              disabled={isSubmittingForm}>
              {textActivatedBtn}
            </button>
          </span>}
          <span className='pull-right'>
            <button
              type='button'
              className={`btn btn-default ${styles['btn-cancel']}`}
              onClick={this._onClickCancel}
              disabled={isSubmittingForm}>
              Cancel
            </button>
            {outlets.length > 1 && salesTypeDetail === null &&
              <button
                type='button'
                className={`btn btn-primary mr-10px`}
                onClick={handleSubmit(this._onSubmitToAllOutlet)}
                disabled={isSubmittingForm}>
                Save to All Outlets
              </button>
            }
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={handleSubmit(this._onSubmit)}
              type='button'
              disabled={isSubmittingForm}>
              Save
            </button>
          </span>
        </div>
      </div>
    )
  }

  _onClickCancel = (event) => {
    this.props.dispatch(onClickCancel())
    event.preventDefault()
    event.stopPropagation()
  }

  _onClickDelete = (event) => {
    const {dispatch, salesTypeDetail} = this.props
    dispatch(deleteSalesTypeRequest(salesTypeDetail))
    event.preventDefault()
    event.stopPropagation()
  }

  _onClickActivated = (event) => {
    const {dispatch, salesTypeDetail} = this.props
    dispatch(activatedSalesTypeRequest(salesTypeDetail))
    event.preventDefault()
    event.stopPropagation()
  }

  _onSubmitToAllOutlet = (values) => {
    this.props.onSubmit({...values, action: 'saveToAllOutlet'})
  }

  _onSubmit = (values) => {
    this.props.onSubmit({...values, action: 'save'})
  }
}

const selector = formValueSelector('salesType')

const mapForm = {
  form: 'salesType',
  touchOnBlur: false,
  touchOnChange: true,
  validate
}

function mapStateToProps (state) {
  const {salesType, salesTypeDetail, outlets, isSubmittingForm, gratuity, enableGratuity} = state.library.salesType
  return {
    salesType,
    salesTypeDetail,
    outlets,
    salesTypeId: {id: selector(state, 'id')},
    isSubmittingForm,
    gratuity,
    enableGratuity
  }
}

export default connect(mapStateToProps)(reduxForm(mapForm)(SalesTypeForm))



// WEBPACK FOOTER //
// ./app/pages/Library/SalesType/SalesTypeDetail/SalesTypeForm.js